import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store";
import {
  fetchProvisionBillingPreview,
  ProvisionBillingPreviewRequest,
  resetProvisionBillingPreview,
} from "../../../../store/slices/ProvisionBillingPreviewSlice";

const useProvisionBillingPreview = () => {
  const dispatch = useDispatch<AppDispatch>();
  const requestRef = useRef<{ abort: () => void } | null>(null);
  const previewState = useSelector(
    (state: RootState) => state.ProvisionBillingPreviewSlice,
  );

  const requestPreview = useCallback(
    (request: ProvisionBillingPreviewRequest) => {
      requestRef.current?.abort();
      requestRef.current = dispatch(fetchProvisionBillingPreview(request));
    },
    [dispatch],
  );

  const resetPreview = useCallback(() => {
    requestRef.current?.abort();
    requestRef.current = null;
    dispatch(resetProvisionBillingPreview());
  }, [dispatch]);

  useEffect(
    () => () => {
      resetPreview();
    },
    [resetPreview],
  );

  return {
    ...previewState,
    requestPreview,
    resetPreview,
  };
};

export default useProvisionBillingPreview;
